import { render, staticRenderFns } from "./OxygenAction.vue?vue&type=template&id=1461318c&scoped=true&"
import script from "./OxygenAction.vue?vue&type=script&lang=js&"
export * from "./OxygenAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461318c",
  null
  
)

export default component.exports